import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-footer',
  imports: [],
  templateUrl: './sidebar-footer.component.html',
  styleUrl: './sidebar-footer.component.scss'
})
export class SidebarFooterComponent {

}
